<template>
  <div class="login-container">
    <div class="content">
      <div class="login-bg"></div>
      <div class="content-wrap">
        <div class="content-body">
          <!--登录-->
          <div class="title"></div>
          <el-form ref="loginForm" :model="loginForm" :rules="loginRules" style="width: 300px;">
            <el-form-item prop="loginname">
              <el-input placeholder="请输入用户名" maxlength="11" clearable v-model.number="loginForm.loginname"></el-input>
              <i class="userIcon"></i>
            </el-form-item>
            <el-form-item prop="password" style="margin-bottom: 26px;">
              <el-input placeholder="请输入登录密码" maxlength="16" name="password" type="password" autoComplete="on" clearable
                        v-model="loginForm.password"
                        @keyup.enter.native="handleLogin(1)">
              </el-input>
              <i class="passIcon"></i>
            </el-form-item>
            <el-form-item>
              <!--<el-button class="login-btn" @click="handleLogin(0)">登录老版本</el-button>-->
              <el-button class="login-btn" @click="handleLogin(1)">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="tip-wrap">
            <span @click="findPwdBoo=true">忘记密码，点击找回</span>
          </div>
        </div>
        <div class="aq-class">
          <a href="http://www.beian.miit.gov.cn/" target="_blank">鄂ICP备18015935号</a>
        </div>
      </div>
    </div>
    <!--找回密码弹窗-->
    <!--更换手机号-->
    <el-dialog title="找回密码" :visible.sync="findPwdBoo" class="retrieve_pass" :modal-append-to-body="false" width="480px" @close="closePhoneDia">
      <div class="crumbs">
        <ul>
          <li :class="[active==1?'current':'']"><span>1.验证手机号</span></li>
          <!--<li :class="[active==3?'current':'']"><span>3.密码重置成功</span></li>-->
          <li :class="[active==2?'current':'']"><span>2.设置新密码</span></li>
        </ul>
      </div>
      <el-form :model="resetForm1" ref="resetForm1" :rules="resetRules1" v-show="active==1" label-width="100px">
        <el-form-item label="原手机号：" prop="phoneNum">
          <el-input placeholder="请输入手机号" v-model="resetForm1.phoneNum" clearable maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="messageCode">
          <el-input placeholder="请在此输入验证码" v-model="resetForm1.messageCode" clearable maxlength="6">
            <el-button slot="append" @click="getCode" :disabled="reset.canGetCode">{{reset.loginCodeTxt}}</el-button>
          </el-input>
        </el-form-item>
        <el-form-item class="handle-btn-wrap clearfix">
          <el-button type="primary" style="width: 100%;" @click="next">下一步</el-button>
        </el-form-item>
      </el-form>
      <el-form :model="resetForm2" ref="resetForm2" :rules="resetRules2" v-show="active==2" label-width="100px">
        <el-form-item label="新密码：" prop="password">
          <el-input type="password" placeholder="请输入新密码" v-model="resetForm2.password" clearable maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="newPassword">
          <el-input type="password" placeholder="请确认密码" v-model="resetForm2.newPassword" clearable maxlength="20"></el-input>
        </el-form-item>
        <el-form-item class="handle-btn-wrap">
          <el-button style="width: 100%;" type="primary" @click="confirmPwd">确认修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!--   <el-dialog title="找回密码" :visible.sync="findPwdBoo">
         <el-steps :active="active" simple>
           <el-step title="1.验证手机号码" icon=""></el-step>
           <el-step title="2.设置新密码" icon=""></el-step>
         </el-steps>
         <div class="w400 m-auto" style="margin-top: 40px;">
           <el-form :model="pwdForm" :rules="pwdRules" ref="pwdRef" label-width="80px" size="medium" v-if="active==1">
             <el-form-item label="账号：" prop="jwPhone">
               <el-input placeholder="请输入手机号" v-model="pwdForm.jwPhone" maxlength="11" clearable></el-input>
             </el-form-item>
             <el-form-item label="验证码：" prop="jwCode">
               <el-input placeholder="请输入验证码" v-model="pwdForm.jwCode" clearable maxlength="6" style="width: 190px;"></el-input>
               <el-button :disabled="msgDisabled" @click="sendCode" style="width: 125px;">{{tipText}}</el-button>
             </el-form-item>
             <el-form-item>
               <el-button type="primary" class="w100" @click="nextStep">下一步</el-button>
             </el-form-item>
           </el-form>
           <el-form :model="newPwdForm" :rules="newPwdRules" ref="newPwdRef" label-width="80px" size="medium" v-else>
             <el-form-item label="账号：" prop="jwPhone">
               <el-input placeholder="请输入新密码" v-model="pwdForm.jwPhone" maxlength="20" clearable></el-input>
             </el-form-item>
             <el-form-item label="确认密码：" prop="jwCode">
               <el-input placeholder="请再次输入新密码" v-model="pwdForm.jwCode" clearable maxlength="20"></el-input>
             </el-form-item>
             <el-form-item>
               <el-button type="primary" class="w100" @click="nextStep">确认提交</el-button>
             </el-form-item>
           </el-form>
         </div>
       </el-dialog>-->
    <!--    <el-dialog title="选择门店" :visible.sync="storeBoo">
          <el-select v-model="storeForm.storeId">
            <el-option v-for="item in storeList" :label="item.storeName" :value="item.id" :key="item.id"></el-option>
          </el-select>
          <div slot="footer" style="text-align: left;">
            <el-button type="primary" @click="login">确定</el-button>
          </div>
        </el-dialog>-->
  </div>
</template>

<script>
  import { removeToken } from '@/utils/auth.js'
  import Logan from 'logan-web';

  export default {
    name: 'login',
    data () {
      const checkPassword = (rule, value, callback) => {  //确认密码
        let v = value.toString().trim()
        // let flag = /^[a-zA-Z0-9_]{8,16}$/.test(v);
        let flag = /[^\u4e00-\u9fa5]{6,20}$/.test(v)
        if (!flag) {
          if (callback) callback(new Error('密码格式由6-20位的非汉字组成!'))
        } else {
          callback()
        }
      }
      const passwordReg = (rule, value, callback) => {//密码
        if (value == undefined) {
          return callback()
        }
        let v = value.toString().trim()
        let flag = /^[a-zA-Z0-9_`~!@#$%^&*()\-_+={[\]\}\?:;'"|<,.>/]{6,20}$/.test(v)
        // let flag = /^[a-zA-Z0-9_`~!@#$%^&*()\-_+={[\]\}\?:;'"|<,.>/]{8,16}$/.test(v);  //180522改为8-16位密码 by:jw
        // let flag = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(v)   //180530  密码由数字和字母组成  by:jw
        if (!flag) {
          if (callback) callback(new Error('请设置6-20位密码，且包含数字、字母、符号至少两种'))
        } else {
          callback()
        }
      }
      const confirmReg = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      const againPwd = (rule, value, callback) => {
        if (this.resetForm2.password != value) {
          callback(new Error('两次密码输入不一致'))
        } else {
          callback()
        }
      }
      return {
        //更改手机号
        resetForm1: {
          phoneNum: '',
          messageCode: ''
        },
        reset: {
          timer: null,
          count: 60,
          loginCodeTxt: '获取验证码',  // 登录获取验证码
          canGetCode: false,  //获取验证码按钮是否禁用
        },
        //重置密码验证规则1
        resetRules1: {
          phoneNum: [{required: true, validator: this.$Util.RegExp.phoneReg}],
          messageCode: [{required: true, message: '请输入验证码'}],
        },
        //重置密码
        resetForm2: {
          password: '',
          newPassword: '',
          userId: ''
        },
        //修改密码_校验
        resetRules2: {
          password: [{required: true, validator: this.$Util.RegExp.passwordReg}],
          newPassword: [{required: true, message: '请再次输入密码'}, {validator: againPwd}]
        },
        active: 1,
        findPwdBoo: false, //找回密码显隐
        storeBoo: false, //门店显隐
        loginForm: {
          loginname: '',
          password: '',
        },
        storeForm: {
          storeId: '',
          userId: ''
        },
        // 登录验证规则
        loginRules: {
          loginname: [{required: true, trigger: 'change', validator: this.$Util.RegExp.phoneReg}],
          password: [{required: true, trigger: 'change', validator: checkPassword}],
        },
        storeList: [],
        //找回密码的表单
        pwdForm: {
          jwPhone: '',
          jwCOde: ''
        },
        pwdRules: {
          jwPhone: [{required: true, trigger: 'change', message: '请输入手机号'}, {validator: this.$Util.RegExp.phoneReg}],
          jwCode: [{required: true, trigger: 'change', message: '请输入验证码'}]
        },
        newPwdForm: {
          jwPhone: '',
          jwCOde: ''
        },
        newPwdRules: {
          jwPhone: [{required: true, trigger: 'change', message: '请输入新密码'}, {validator: passwordReg}],
          jwCode: [{required: true, trigger: 'change', message: '请再次输入新密码'}, {validator: againPwd}]
        },
        msgDisabled: false,
        tipText: '发送验证码',
        timer: null,
        num: 60,
      }
    },
    components: {},
    methods: {
      closePhoneDia () {},
      //确认修改
      confirmPwd () {
        Logan.logWithEncryption('忘记密码或修改密码确认修改', 1);
        this.$refs.resetForm2.validate(valid => {
          if (valid) {
            // let obj = JSON.parse(JSON.stringify(this.resetForm2))

            let obj = {loginName: this.resetForm1.phoneNum, password: this.resetForm2.newPassword}
            // delete obj.password
            this.$ajaxPost('user/login/modifiedPassWordPC', obj).then(({data}) => {
              if (data.responseCode == 200) {
                setTimeout(() => {
                  this.$message.success('密码修改成功，请使用新密码登录')
                  this.findPwdBoo = false
                  this.active = 1
                }, 500)
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          }
        })
      },
      //忘记密码获取验证码
      getCode () {
        Logan.logWithEncryption('忘记密码获取验证码', 1);
        this.$refs.resetForm1.validateField('phoneNum', (val) => {
          // 当val==''时表示校验通过
          if (val == '') {
            this.$ajaxPost('user/login/appSendMessage', {phoneNo: this.resetForm1.phoneNum}).then(({data}) => {
              if (data.responseCode == 200) {
                clearInterval(this.reset.timer)
                this.reset.timer = setInterval(() => {
                  if (this.reset.count == 0) {
                    clearInterval(this.reset.timer)
                    this.reset.loginCodeTxt = '获取验证码'
                    this.reset.canGetCode = false
                    this.reset.count = 60
                  } else {
                    this.reset.count--
                    this.reset.loginCodeTxt = '再次获取 ' + this.reset.count + ' s'
                    this.reset.canGetCode = true
                  }
                }, 1000)
                this.$message.success('验证码发送成功')
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          } else {
            return false
          }
        })
      },
      //下一步
      next () {
        this.$refs.resetForm1.validate(valid => {
          if (valid) {
            this.$ajaxPost('user/login/verifyMessageCodePC', {loginname: this.resetForm1.phoneNum, messageCode: this.resetForm1.messageCode}).then(({data}) => {
              if (data.responseCode == 200) {
                this.active = 2
                this.reset.loginCodeTxt = '获取验证码'
                this.reset.canGetCode = false
                this.reset.count = 60
                this.resetForm2.userId = data.result
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          }
        })
      },
      //登录
      handleLogin (upgraded) {
        Logan.logWithEncryption('点击登录', 1);
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            this.$ajaxPost('user/login/loginAdmin', this.loginForm).then(({data}) => {
              if (data.responseCode == 200) {
                this.storeList = data.result.storeList
                // this.storeBoo = true
                this.storeForm.storeId = this.storeList[0].id
                this.storeForm.userId = data.result.userId
                localStorage.setItem('storeId', this.storeForm.storeId)
                this.login(upgraded)
              } else {
                this.$message.error(data.responseMsg)
              }
            })
          }
        })
      },
      /* getNavMenu(role_id) {   //请求菜单
         this.$ajaxGet("member/get_power", {mid: this.$Cookies.get('id')}).then(({data}) => {
           if (data.code === 1) {
             //存储导航栏
             sessionStorage.setItem('menu_list', JSON.stringify(data.data.result));
             this.$router.push({path: '/shop_manage'})
           } else {
             this.$message.error(data.msg);
           }
         });
       },*/
      // 获取存储的用户名密码
      getUserName () {
        if (this.$Cookies.get('loginForm')) {
          let loginForm = JSON.parse(this.$Cookies.get('loginForm'))
          this.loginForm.loginname = loginForm.loginname
          this.loginForm.password = loginForm.password
        }
      },
      // 登录
      login (upgraded) {
        this.$Cookies.set('upgraded', upgraded);
        const url = `/user/login/loginAndSelectStorePc`;
        this.$ajaxPost(url, this.storeForm).then(({data}) => {
          this.$message.success('登录成功')
          this.$Cookies.set('loginForm', this.loginForm, {expires: 30})
          this.$Cookies.set('userInfo', data.result.userInfo, {expires: 30})
          this.$store.dispatch('LoginByUsername', data) //存储获取的token到cookie
          localStorage.setItem('menu_list', JSON.stringify(data.result.module))
          this.$router.push({path: '/index'});
          // setTimeout(() => {
          //   window.location.reload(true);
          // }, 420);
        })
      },
      sendCode () {
        this.$message.success('验证码发送成功')
        this.msgDisabled = true
        this.timer = setInterval(() => {
          this.num--
          this.tipText = `${this.num}s重新获取`
        }, 1000)
        this.$ajaxPost('暂无接口', {}).then(({data}) => {
          if (data.responseCode == 200) {
            this.$message.success('验证码发送成功')
            this.timer = setInterval(() => {
              this.num--
              this.tipText = `${this.num}s重新获取`
            }, 1000)
          } else {
            this.$message.error(data.responseMsg)
          }
        })
      },
      // 下一步
      nextStep () {
        this.$refs.pwdRef.validate(valid => {
          if (valid) {
            this.active = 2
          }
        })
      }
    },
    mounted () {
      /*    if (this.$Cookies.get('status') == 403) {
            removeToken()
            this.$message.error('登录失效，请重新登录！')
          }*/
      this.getUserName()
    },
    watch: {
      num (v) {
        if (v == 0) {
          clearInterval(this.timer)
          this.num = 60
          this.msgDisabled = false
          this.tipText = '获取验证码'
        }
      },
      active (v) {
        if (v != 1) {
          clearInterval(this.reset.timer)
          this.reset.count = 60
          this.reset.loginCodeTxt = '获取验证码'
          this.reset.canGetCode = false
        }
      },
      findPwdBoo (v) {
        if (v == false) {
          this.active = 1
          clearInterval(this.reset.timer)
          this.reset.count = 60
          this.reset.loginCodeTxt = '获取验证码'
          this.reset.canGetCode = false
          this.$refs.resetForm1.resetFields()
        }
      }
    }
  }
</script>
<!--覆盖element样式-->
<style lang="scss">
  #app .login-container {
    .el-input-group__append, .el-input-group__prepend {
      background-color: transparent;
    }

    /*    .el-button {
          padding: 12px 11px
        }*/
    .el-form-item {
      margin-bottom: 22px;

      .userIcon {
        position: absolute;
        top: 12px;
        left: 20px;
        display: inline-block;
        width: 17px;
        height: 20px;
        background: url("../../assets/images/sprite.png") 0 -806px no-repeat;
      }

      .passIcon {
        position: absolute;
        top: 12px;
        left: 20px;
        display: inline-block;
        width: 17px;
        height: 20px;
        background: url("../../assets/images/sprite.png") 0 -846px no-repeat;
      }
    }

    .content-body {
      .el-input__inner, .el-textarea__inner {
        border: 1px solid #cfd2d2;
        width: 300px;
        height: 44px;
        padding-left: 51px;
      }

      .el-form-item__error {
        left: 46px;
      }
    }

    .aq-class {
      text-align: center;
      margin-top: 30px;
      a {
        color: #5a5a5a;
      }
    }

    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border: 1px solid #537fb7;
    }

    .handle-btn-wrap {
      margin-top: 50px;
      margin-bottom: 0;

      .el-button {
        width: 200px;
        background-color: #537fb7;
        font-size: 20px;
        color: #fff;

        &:active {
          color: #fff;
          border-color: #537fb7;
        }
      }
    }

  }
</style>
<style scoped lang="scss">
  *, *:before, *:after {
    box-sizing: border-box;
  }

  #app .retrieve_pass {
    /*步骤条*/
    .crumbs {
      text-align: center;
      margin-bottom: 40px;
      background: #fff;

      .current {
        span {
          color: #537fb7;

          &:after {
            border-left-color: #f4f4f4;
          }
        }
      }
    }

    .crumbs ul {
      list-style: none;
      display: inline-table;
      width: 100%;
    }

    .crumbs ul li {
      display: table-cell;
      width: 30%;
      text-align: center;
    }

    .crumbs ul li span {
      display: block;
      height: 40px;
      line-height: 40px;
      padding-left: 30px;
      background: #f4f4f4;
      color: #666;
      position: relative;
      margin: 0 10px 0 0;
      font-size: 14px;
      text-decoration: none;
    }

    .crumbs ul li span:after {
      content: "";
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #f4f4f4;
      position: absolute;
      right: -20px;
      top: 0;
      z-index: 1;
    }

    .crumbs ul li span:before {
      content: "";
      border-top: 20px solid transparent;
      border-bottom: 20px solid transparent;
      border-left: 20px solid #fff;
      position: absolute;
      left: 0;
      top: 0;
    }

    .crumbs ul li:first-child span:before {
      display: none;
    }

    .crumbs ul li:last-child span {
      margin-right: 0;
    }

    .crumbs ul li:last-child span:after {
      display: none;
    }
  }

  .login-container {
    position: relative;

    .login-bg {
      width: 100%;
      height: 100%;
      position: fixed;
      background: url("../../assets/images/login-bg0.png") 0 0 no-repeat;
      background-size: cover;
    }

    .content {
      position: relative;

      .content-wrap {
        width: 682px;
        min-height: 482px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -341px;
        margin-top: 241px;
        background: url("../../assets/login-bg1.png") 0 0 no-repeat;
      }

      .content-body {
        min-height: 360px;
        width: 400px;
        padding: 33px 50px;
        margin: 15px;

        .title {
          width: 100%;
          height: 34px;
          margin: 36px 0 40px 0;
          background: url("../../assets/images/sprite.png") 0 -886px no-repeat;
        }
      }
    }

    .login-btn {
      width: 100%;
      background: #537fb7;
      border-radius: 4px;
      font-size: 20px;
      color: #fff;
    }

    .copyright {
      margin-top: 30px;
      text-align: center;
      font-size: 14px;
      color: #898989;

      .en {
        font-size: 12px;
      }
    }

    .tip-wrap {
      font-size: 14px;
      color: #666;
      text-align: center;

      span {
        cursor: pointer;
      }
    }

    /deep/ .el-step.is-simple .el-step__icon {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/login/index.vue